export default __webpack_public_path__ + "static/5-279a145cb1557367c6466d495ea574bc.png";